module.exports = __webpack_public_path__ + "images/category_lp/camera/man_30_83a28a97c1a04113193b1e1ae510ab2d.png";